import React from 'react'

function homeText() {
    return (
        <div id = "homeText">
            <p id="homeTextTitle">This Website Displays Poetry</p>
            <div className="spinnyboi">
            Wow
            </div>
        </div>
    )
}
 export default homeText


// WEBPACK FOOTER //
// ./src/Components/homeText.js